import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { RootState } from '../../store';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const session = useSelector((state: RootState) => state.sessionReducers);

  if (!session.logged) {
    return <Redirect to="/" />;
  }

  if (
    allowedRoles &&
    !allowedRoles.includes(session.user?.currentRole as string)
  ) {
    return <Redirect to="/dashboard" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
